import "./drawer.css";
import DrawerFooter from "./DrawerFooter";
import DrawerHeader from "./DrawerHeader";

interface AppDrawerProps {
  title: string;
  subtitle: string;
  cancel?: string;
  submit?: string;
  openDrawer: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  onSubmit?: () => void;
  variant?: "default" | "grey";
  size?: "small" | "medium" | "large" | "full";
}

const AppDrawer = ({
  title,
  subtitle,
  openDrawer,
  cancel,
  submit,
  onClose,
  children,
  onSubmit,
  variant = "default",
  size = "medium",
}: AppDrawerProps) => {
  const drawerClass = `gx-app-drawer ${openDrawer ? "open" : ""} ${
    variant === "grey" ? "gx-app-drawer-grey" : ""
  } ${
    size === "small"
      ? "gx-app-drawer-small"
      : size === "large"
        ? "gx-app-drawer-large"
        : size === "full"
          ? "gx-app-drawer-full"
          : ""
  }`.trim();

  return (
    <div className={`backdrop ${openDrawer ? "visible" : "hidden"}`}>
      <div className={drawerClass}>
        {/* Drawer Header - pass variant prop */}
        <DrawerHeader
          title={title}
          subtitle={subtitle}
          handleClose={onClose ?? (() => {})}
          variant={variant} // Pass variant to header
        />

        {/* Drawer Body */}
        <div
          className={`drawer-content ${variant === "grey" ? "drawer-content-grey" : ""}`}
        >
          {children}
        </div>

        {/* Drawer Footer */}
        <DrawerFooter
          handleClose={onClose ?? (() => {})}
          handledrawerSubmit={onSubmit ?? (() => {})}
          cancel={cancel}
          submit={submit}
        />
      </div>
    </div>
  );
};

export default AppDrawer;
